<ion-app>
  <!-- The menu stays pinned until Ionic's responsive breakpoint collapses it, or the user collapses it. -->
  <ion-split-pane
    contentId="main-content"
    [when]="menuCollapsed ? false : 'lg'"
    (ionSplitPaneVisible)="onSplitPaneChange($event)"
  >
    <ion-menu contentId="main-content" type="overlay" class="efb-menu">
      <ion-content class="menu-content">
        <div class="menu-shell">
          <div class="menu-pin-row" *ngIf="menuPinned || menuCollapsed">
            <!-- Two buttons with a static label: ion-button throws if aria-label changes before the button has loaded. -->
            <ion-button
              *ngIf="menuCollapsed"
              fill="clear"
              size="small"
              aria-label="Pin menu"
              (click)="setMenuCollapsed(false)"
            >
              <ion-icon slot="icon-only" name="pin-outline"></ion-icon>
            </ion-button>
            <ion-button
              *ngIf="!menuCollapsed"
              fill="clear"
              size="small"
              aria-label="Close menu"
              (click)="setMenuCollapsed(true)"
            >
              <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
            </ion-button>
          </div>
          <!-- ===================================================== -->
          <!-- HEADER -->
          <!-- ===================================================== -->

          <div class="menu-topbar">
            <div class="menu-context">
              <button
                type="button"
                class="menu-aircraft-title menu-summary-action"
                (click)="showMenuReport('aircraft')"
                [disabled]="menuReportLoading || !generalSettings?.registration"
                aria-label="View aircraft report"
              >
                <span class="menu-eyebrow">Aircraft</span>
                <span class="menu-registration">{{ generalSettings?.registration || "Aircraft" }}</span>
                <span
                  class="menu-aircraft-details"
                  *ngIf="opsControlSer.acftType || generalSettings?.base?.name || bindingClaims()?.bound === false"
                >
                  <span *ngIf="opsControlSer.acftType" class="menu-aircraft-type">{{ opsControlSer.acftType }}</span>
                  <span *ngIf="generalSettings?.base?.name" class="menu-base">{{ generalSettings.base.name }}</span>
                  <span *ngIf="bindingClaims()?.bound === false" class="menu-base">{{
                    translate.instant("NotBound")
                  }}</span>
                </span>
              </button>
              <button
                type="button"
                class="menu-crew menu-summary-action"
                (click)="showMenuReport('crew')"
                [disabled]="menuReportLoading || !generalSettings?.registration"
                aria-label="View crew report"
              >
                <span class="menu-crew-heading">
                  <span class="menu-eyebrow">Crew</span>
                  <span class="menu-duty-status" *ngIf="opsControlSer.crewDesig">{{
                    opsControlSer.crewDesig.replace("-", " ") | lowercase
                  }}</span>
                  <ion-badge *ngIf="opsControlSer.duty_has_changes" color="warning">Changed</ion-badge>
                </span>
                <span class="menu-crew-name">{{ opsControlSer.pic || "Awaiting crew data" | titlecase }}</span>
              </button>
              <ion-menu-toggle [autoHide]="false" *ngIf="isSidebarPageEnabled('/duty-ofp-limits')">
                <ion-button class="menu-duty-action" expand="block" (click)="openDutyLimits()">
                  <ion-icon slot="start" name="create-outline" aria-hidden="true"></ion-icon>
                  Duty limits &amp; signing
                </ion-button>
              </ion-menu-toggle>
            </div>
            <ion-button
              *ngIf="!menuPinned"
              fill="clear"
              class="menu-close-button"
              aria-label="Close menu"
              (click)="closeMenu()"
            >
              <ion-icon name="close-outline"></ion-icon>
            </ion-button>
          </div>

          <!-- ===================================================== -->
          <!-- MAIN NAVIGATION -->
          <!-- ===================================================== -->

          <div class="menu-section" *ngIf="hasOperationsPages">
            <div class="menu-section-title">Flight operations</div>

            <ion-list class="menu-list" lines="none">
              <ng-container *ngFor="let p of appPages; let i = index">
                <ion-menu-toggle *ngIf="p.section === 'operations' && isSidebarPageEnabled(p.url)" auto-hide="false">
                  <!-- A button, not a routerLink: Ionic lets a modifier click on a link open a browser tab. -->
                  <ion-item
                    button
                    class="menu-nav-item"
                    [class.selected]="isPageActive(p.url)"
                    (click)="openPage(p.url)"
                    lines="none"
                    detail="false"
                  >
                    <div slot="start" class="menu-icon-wrapper">
                      <ion-icon [ios]="p.icon + '-outline'" [md]="p.icon + '-outline'"></ion-icon>
                    </div>

                    <ion-label>
                      {{ p.title }}
                    </ion-label>

                    <ion-badge *ngIf="p.numberBatch > 0" slot="end" color="primary">
                      {{ p.numberBatch }}
                    </ion-badge>
                  </ion-item>
                </ion-menu-toggle>
              </ng-container>
            </ion-list>
          </div>

          <div class="menu-divider" *ngIf="hasOperationsPages && hasToolsPages"></div>

          <!-- ===================================================== -->
          <!-- TOOLS / DATA -->
          <!-- ===================================================== -->

          <div class="menu-section" *ngIf="hasToolsPages">
            <div class="menu-section-title">Tools & data</div>

            <ion-list class="menu-list" lines="none">
              <ng-container *ngFor="let p of appPages; let i = index">
                <ion-menu-toggle *ngIf="p.section === 'tools' && isSidebarPageEnabled(p.url)" auto-hide="false">
                  <!-- A button, not a routerLink: Ionic lets a modifier click on a link open a browser tab. -->
                  <ion-item
                    button
                    class="menu-nav-item"
                    [class.selected]="isPageActive(p.url)"
                    (click)="openPage(p.url)"
                    lines="none"
                    detail="false"
                  >
                    <div slot="start" class="menu-icon-wrapper">
                      <ion-icon [ios]="p.icon + '-outline'" [md]="p.icon + '-outline'"></ion-icon>
                    </div>

                    <ion-label>
                      {{ p.title }}
                    </ion-label>

                    <ion-badge *ngIf="p.numberBatch > 0" slot="end" color="primary">
                      {{ p.numberBatch }}
                    </ion-badge>
                  </ion-item>
                </ion-menu-toggle>
              </ng-container>
            </ion-list>
          </div>

          <!-- Push footer to bottom -->
          <div class="menu-spacer"></div>

          <div class="menu-divider"></div>

          <!-- ===================================================== -->
          <!-- LOGOUT -->
          <!-- ===================================================== -->

          <div class="menu-footer">
            <ion-menu-toggle auto-hide="false">
              <ion-item button class="menu-nav-item logout-item" lines="none" detail="false" (click)="logout()">
                <div slot="start" class="menu-icon-wrapper">
                  <ion-icon name="log-out-outline"></ion-icon>
                </div>

                <ion-label> Logout </ion-label>
              </ion-item>
            </ion-menu-toggle>
          </div>
        </div>
      </ion-content>
    </ion-menu>

    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
  <button *ngIf="wallboardIdle.noDuty" type="button" class="no-duty-bar" (click)="openDutyLimits()">
    <ion-icon name="warning" aria-hidden="true"></ion-icon>
    {{ translate.instant("wallboardNoDuty") }}
  </button>
  <app-mission-popup></app-mission-popup>
</ion-app>
